/* eslint-disable @typescript-eslint/naming-convention */
import { useMemo } from 'react'
import map from 'lodash/map'
import { useDomainMessages } from 'domains/products/utils/domain/intl'
import { type Product, type ProductImage } from 'domains/products/components/view/utils/types'

export const useProductImages = (imageList: Product['imageList']) => {
  const labels = useDomainMessages({
    angle_left: 'productsDomain.view.details.sections.images.angleLeft',
    angle_right: 'productsDomain.view.details.sections.images.angleRight',
    angle_back: 'productsDomain.view.details.sections.images.angleBack',
    angle_top: 'productsDomain.view.details.sections.images.angleTop',
    ingredients: 'productsDomain.view.details.sections.images.ingredients',
    nutrition: 'productsDomain.view.details.sections.images.nutrition',
    supplements: 'productsDomain.view.details.sections.images.supplements',
    drugs: 'productsDomain.view.details.sections.images.drugs',
    lifestyle: 'productsDomain.view.details.sections.images.lifestyle',
  })

  const secondaryImages: ProductImage[] = useMemo(() => {
    const images = (imageList ?? []).reduce(
      (acc, { imageUrl, imageType }) => {
        if (!(imageType in acc)) return acc // Ignore unknown image types
        if (acc[imageType]) return acc // Ignore if we already have an image

        acc[imageType] = {
          url: imageUrl,
          type: imageType,
          label: labels[imageType],
        }

        return acc
      },
      {
        angle_left: null,
        angle_right: null,
        angle_back: null,
        angle_top: null,
        ingredients: null,
        nutrition: null,
        supplements: null,
        drugs: null,
        lifestyle: null,
      } as Record<string, ProductImage>
    )

    return map(images, (image, type) => {
      if (image) return image

      return { url: null, type, label: labels[type] }
    })
  }, [imageList, labels])

  return secondaryImages
}
